import { palette } from './palette';
import background from 'assets/images/faq-banner-img.webp';
import testimonialBg from 'assets/images/testimonialBg.webp';
import YesIcon from 'assets/images/yes-icon.svg';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      '& .hero-shaped__left-side': {
        flex: '0 0 60%',
        maxWidth: '60%',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          flex: '0 0 50%',
          maxWidth: '50%',
        },

        '& .hero-shaped__image': {
          width: '60vw',

          '@media(min-width: 900px) and (max-width: 1200px)': {
            width: '50vw',
          },
        },
      },
    },
  },

  '.smartyplans-container, .smartyplans-container': {
    '& .app-main-box': {
      background: palette.background.light
    },
    '& .normal-text': {
      fontWeight: 300,
    },
    '& .MuiButton-sizeLarge': {
      fontSize: '16px !important',
      lineHeight: '20px',
      padding: '12px 24px !important',
    },
    '& .hero-link-button.MuiButton-root, & .login-button.MuiButton-root': {
      fontSize: '16px !important',
      fontWeight: 400,
      letterSpacing: '-0.32px',
      lineHeight: '20px',
      padding: '12px 24px !important',
    },
    '& .header-wrapper': {
      '& .MuiToolbar-root': {
        minHeight: 82,
      },
      '& .top-bar-logo-container': {
        height: 56,
      },
      '& .top-bar-logo-container .image': {
        height: '56px',
        width: 'auto',
      },
    },

    '& .savings-hero-section, .checkout-hero-section, .plan-selection-section, .faq-hero-section, .dashboard-hero-section, .find-provider-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
      {
        marginTop: '64px',
        background: palette.background.header,
        '& .hero-header-title': {
          color: palette.primary.main,
        },
        '& .hero-header-subtitle': {
          color: palette.text.primary,
        },
      },

    '& .dashboard-hero-section .hero-header-title': {
      color: `${palette.text.highlight} !important`,
    },

    '& .checkout-outer-container, .plan-selection-container': {
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      backgroundColor: palette.background.hero,

      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '680px',
        '& .section-header': {
          '@media screen and (min-width: 768px)': {
            marginTop: '60px',
          },
        },
      },
      '&.home-hero-variant-3': {
        paddingBottom: 0,
        '& .hero-image-side': {
          overflow: 'visible',
        },
        '& .hero-split-image': {
          height: 'calc(100% - 68px)',
          left: -42,
          objectFit: 'contain',
          objectPosition: 'left center',
          top: 18,
          width: 'calc(100% + 24px)',
        },
        '@media screen and (max-width: 900px)': {
          paddingBottom: 0,
          '& .hero-content-side': {
            alignItems: 'center',
            textAlign: 'center',
          },
          '& .section-header, & .section-header__title, & .section-header__subtitle':
            {
              textAlign: 'center',
            },
          '& .section-header__title, & .section-header__subtitle': {
            marginLeft: 'auto',
            marginRight: 'auto',
          },
          '& .section-header__cta-wrapper': {
            justifyContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
          },
          '& .section-header__cta-container': {
            justifyContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto',
          },
          '& .section-header__cta-item-wrapper': {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          '& .hero-image-side': {
            display: 'flex',
            justifyContent: 'center',
          },
          '& .hero-split-image': {
            height: '100%',
            left: 0,
            objectPosition: 'center center',
            top: 0,
            width: '100%',
          },
        },
      },
      '& .home-hero-title': {
        color: palette.text.primary,
        fontSize: '64px',
        letterSpacing: '-3.2px',
        lineHeight: '72px',
        marginBottom: '24px',
      },
      '& .home-hero-pretitle': {
        color: palette.primary.main,
        fontSize: '24px',
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        marginBottom: '24px',
      },
      '& .home-hero-pretitle span, & .home-hero-title span': {
        color: palette.primary.main,
        fontWeight: 'inherit',
      },
      '& .home-hero-pretitle span': {
        marginLeft: '0.25em',
      },
      '@media screen and (max-width: 768px)': {
        '& .home-hero-title': {
          fontSize: '40px',
          letterSpacing: '-1.6px',
          lineHeight: '48px',
        },
      },
      '& .hero-title': {
        fontWeight: 'normal',
        maxWidth: 680
      },
      '& .home-hero-subtitle': {
        color: palette.text.secondary,
        fontSize: '20px',
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        marginBottom: '40px',
        maxWidth: 640,
      },
      '& .login-button': {
        color: palette.primary.main,
      },
      '& .header-subtitle-divider': {
        marginTop: 16,
        marginBottom: 16,
        '& .subtitle-divider': {
          width: '50%',
          background: palette.primary.main
        }
      }
    },

    /* Benefits Section - Styles */
    '& .definition-Wrapper': {
      background: palette.background.aboutBenefits,
    },
    '& #definition-section.definition-variant-1': {
      background: palette.background.aboutBenefits,
      overflow: 'hidden',
      padding: 'clamp(56px, 5vw, 96px) 0',
      position: 'relative',

      '&::after': {
        backgroundImage: "url('/images/home-images/smartyplan-monkey-small.png')",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        content: '""',
        height: 220,
        pointerEvents: 'none',
        position: 'absolute',
        right: 'clamp(24px, 7.8125vw, 150px)',
        top: '50%',
        transform: 'translateY(-32%)',
        width: 170,
        zIndex: 0,
      },

      '& .benefits-wrapper': {
        margin: '0 auto',
        maxWidth: 1280,
        paddingRight: 210,
        position: 'relative',
        width: 'calc(100% - 96px)',
        zIndex: 1,
      },

      '& .benefits-wrapper > .MuiGrid-container': {
        flexDirection: 'column',
        gap: 32,
        margin: 0,
        width: '100%',
      },

      '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item': {
        flexBasis: '100%',
        maxWidth: '100%',
        padding: '0 !important',
      },

      '& .section-header': {
        alignItems: 'center',
        margin: 0,
      },

      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },

      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 400,
        letterSpacing: '-1.92px',
        lineHeight: '56px',
        maxWidth: 'none',
        padding: '0 !important',
        textAlign: 'center',
      },

      '& .section-header__subtitle-wrapper, & .section-header__cta-wrapper': {
        display: 'none',
      },

      '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item:nth-child(2) > .MuiGrid-container':
        {
          display: 'grid',
          gap: 0,
          gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
          margin: 0,
          width: '100%',
        },

      '& .service-tile-wrapper': {
        flexBasis: 'auto',
        margin: '0 !important',
        maxWidth: '100%',
        padding: '0 !important',
        position: 'relative',
      },

      '& .service-tile-wrapper:not(:last-child)::after': {
        background: palette.background.aboutBenefitsDivider,
        content: '""',
        height: 124,
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        width: 2,
      },

      '& .definition-service-tile': {
        alignItems: 'center',
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
        flexDirection: 'column',
        gap: 0,
        height: 'auto !important',
        margin: 0,
        minHeight: 'auto !important',
        padding: '24px 28px !important',
        width: '100%',
      },

      '& .definition-service-tile > .MuiGrid-item': {
        padding: '0 !important',
      },

      '& .definition-service-tile > .MuiGrid-item:first-child': {
        alignItems: 'center',
        background: palette.text.highlight,
        borderRadius: '50%',
        display: 'flex',
        height: 72,
        justifyContent: 'center',
        width: 72,
      },

      '& .definition-service-tile > .MuiGrid-item:nth-child(2)': {
        marginTop: 24,
      },

      '& .definition-service-tile > .MuiGrid-item:nth-child(3)': {
        marginTop: 12,
      },

      '& .definition-service-tile .image, & .definition-service-tile img': {
        height: '44px !important',
        maxHeight: 44,
        maxWidth: 44,
        width: '44px !important',
      },

      '& .definition-service-title': {
        color: palette.text.primary,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        textAlign: 'center',
      },

      '& .definition-service-description': {
        color: palette.text.body,
        fontSize: 18,
        fontWeight: 400,
        letterSpacing: '-0.54px',
        lineHeight: '24px',
        textAlign: 'center',
        whiteSpace: 'pre-line',
      },

      '@media screen and (max-width: 1200px)': {
        '&::after': {
          height: 170,
          right: 24,
          width: 130,
        },

        '& .benefits-wrapper': {
          paddingRight: 150,
        },

        '& .definition-service-tile': {
          padding: '24px 18px !important',
        },
      },

      '@media screen and (max-width: 900px)': {
        padding: '56px 24px',

        '&::after': {
          display: 'none',
        },

        '& .benefits-wrapper': {
          paddingRight: 0,
          width: '100%',
        },

        '& .benefits-wrapper > .MuiGrid-container': {
          gap: 40,
        },

        '& .section-header__title': {
          fontSize: 32,
          lineHeight: '40px',
        },

        '& .benefits-wrapper > .MuiGrid-container > .MuiGrid-item:nth-child(2) > .MuiGrid-container':
          {
            gridTemplateColumns: '1fr',
          },

        '& .service-tile-wrapper:not(:last-child)::after': {
          bottom: -20,
          display: 'none',
          height: 2,
          left: '50%',
          right: 'auto',
          top: 'auto',
          transform: 'translateX(-50%)',
          width: 160,
        },

        '& .definition-service-tile': {
          padding: '16px 0 !important',
        },
      },
    },

    /* Membership Value - Styles */
    '& .membership-value-section': {
      '& .membership-value-title, & .membership-value-item-title': {
        color: palette.text.heading,
      },
      '& .membership-value-subtitle, & .membership-value-item-description': {
        color: `${palette.text.body} !important`,
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      color: palette.text.highlight,
      minHeight: 576,
      '& .subscription-bg': {
        height: '100%',
        background: palette.background.level2,
      },
      '& .section-alternate': {
        minHeight: 576,
      },
      '& .subscription-section': {
        alignItems: 'center',
        columnGap: 56,
        display: 'grid',
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        margin: '0 auto',
        maxWidth: 1376,
        minHeight: 576,
        padding: '72px 0 96px',
        width: 'calc(100% - 96px)',
      },
      '& .subscription-section > .MuiBox-root': {
        alignSelf: 'center',
        display: 'block',
        gridColumn: 2,
        gridRow: '1 / span 4',
        justifySelf: 'stretch',
        margin: 0,
        order: 4,
        width: '100%',
      },
      '& .subscription-section .carousel-container': {
        display: 'flex',
        justifyContent: 'center',
      },
      '& .subscription-section .react-multi-carousel-track': {
        justifyContent: 'center',
        width: '100%',
      },
      '& .subscription-section .react-multi-carousel-item': {
        flex: '0 0 500px !important',
        width: '500px !important',
      },
      '& .subscription-section .planCard': {
        maxWidth: '500px',
        width: '500px',
      },
      '& .section-header': {
        gridColumn: 1,
        margin: 0,
        order: 1,
        '& .section-header__title-wrapper': {
          display: 'flex',
          justifyContent: 'flex-start',
          padding: 0,
        }
      },
      '& .section-header__title': {
        fontSize: 48,
        fontWeight: 400,
        letterSpacing: '-1.92px',
        lineHeight: '56px',
        maxWidth: 560,
        padding: 0,
        textAlign: 'left',
      },
      '& .section-header__subtitle-wrapper': {
        padding: '20px 0 0',
      },
      '& .section-header__subtitle': {
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        maxWidth: 560,
        textAlign: 'left',
      },
      '& .section-header__title, & .section-header__subtitle': {
        color: palette.text.highlight,
      },
      '& .summary-subtext': {
        alignSelf: 'start',
        background: palette.text.highlight,
        borderRadius: 12,
        color: palette.primary.main,
        fontSize: 16,
        gridColumn: 1,
        justifySelf: 'start',
        letterSpacing: '-0.32px',
        lineHeight: '20px',
        margin: '40px 0 0',
        order: 2,
        padding: '12px 20px',
        textAlign: 'left',
      },
      '& .summary-subtext .savings-summary-link': {
        color: `${palette.primary.main} !important`,
        textDecoration: 'none !important',
      },
      '& .summary-text': {
        borderTop: `1px solid ${palette.text.highlight}`,
        color: `${palette.text.highlight} !important`,
        fontSize: 20,
        fontWeight: 400,
        gridColumn: 1,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        margin: '48px 0 0',
        order: 3,
        paddingTop: 32,
        textAlign: 'left',
        width: '100%',
      },
      '& #pricing-benefit-section': {
        '& .planCard': {
          '& .description-cta': {
            justifyContent: 'center',
          },
          '& .description-cta__wrapper': {
            width: '100%',
          },
          '& .description-cta__innerWrapper': {
            width: '100%',
          },
          '& .description-cta__title': {
            textAlign: 'center !important',
            width: '100%',
          },
          '& .planCardHeaderContainer': {
            justifyContent: 'center',
            textAlign: 'center',
          },
          '& .customcardTitle, & .customSubscriberName': {
            textAlign: 'center',
            width: '100%',
          },
          '& .customPlanDescription': {
            textAlign: 'center',
          },
          '& .customBenefitsContainer': {
            textAlign: 'left',
          },
          '& .customBenefitsContainer > .MuiGrid-container > .MuiGrid-item:first-child': {
            textAlign: 'left',
          },
          '&:hover': {
            border: `1px solid ${palette.text.primary}`,
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.disabled,
          },
          '& .price-value': {
            color: palette.text.primary,
            fontWeight: 'bold',
          },
          '& .customPlanDescription, & .customButtonWrapper, & .tieredPrimaryPriceItem': {
            display: 'none',
          },
        },
        '& .savings-summary-link': {
          textDecoration: 'underline',
          color: palette.text.highlight,
          cursor: 'pointer',
        },
      },
      '@media screen and (max-width: 1200px)': {
        '& .subscription-section': {
          columnGap: 56,
          width: 'calc(100% - 96px)',
        },
        '& .subscription-section .carousel-container': {
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-list': {
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-item': {
          flex: '1 1 100% !important',
          maxWidth: '100%',
          width: '100% !important',
        },
        '& .subscription-section .planCard': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
      },
      '@media screen and (min-width: 1400px)': {
        '& .subscription-section': {
          columnGap: 120,
          gridTemplateColumns: '560px minmax(0, 1fr)',
        },
      },
      '@media screen and (max-width: 768px)': { 
        '& .subscription-section': {
          display: 'flex',
          flexDirection: 'column',
          gap: 40,
          padding: '56px 24px',
          width: '100%',
        },
        '& .subscription-section .subscription-carousel-wrapper, & .subscription-section > .MuiBox-root':
          {
            width: '100%',
          },
        '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            justifyContent: 'center',
            textAlign: 'center',
          },
        '& .section-header__title': {
          fontSize: 32,
          fontWeight: 400,
          lineHeight: '40px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        },
        '& .section-header__subtitle': {
          fontSize: 16,
          lineHeight: '22px',
          marginLeft: 'auto',
          marginRight: 'auto',
          textAlign: 'center',
        },
        '& .summary-subtext': {
          justifySelf: 'center',
          margin: '0 auto',
          textAlign: 'center',
        },
        '& .summary-text': {
          fontSize: 16,
          marginTop: 0,
          textAlign: 'center',
        },
        '& .subscription-section .carousel-container': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .react-multi-carousel-list, & .subscription-section .react-multi-carousel-track':
          {
            maxWidth: '100%',
            width: '100%',
          },
        '& .subscription-section .react-multi-carousel-item': {
          flex: '1 1 100% !important',
          maxWidth: '100%',
          width: '100% !important',
        },
        '& .subscription-section .carousel-single-item': {
          margin: 0,
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .subscription-plan-card-item, & .subscription-section .carousel-single-item > .MuiGrid-item':
          {
            boxSizing: 'border-box',
            flexBasis: '100% !important',
            maxWidth: '100% !important',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
          },
        '& .subscription-section .planCard': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },
        '& .subscription-section .plan-carousel-item, & .subscription-section .react-multi-carousel-item [class*="carouselItem"]':
          {
            minWidth: '0 !important',
            maxWidth: '100% !important',
            padding: '0 !important',
          },
        '& .subscription-section .planCard .customCardContent': {
          padding: '20px !important',
          '&:last-child': {
            padding: '20px !important',
          },
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.level1,

      '& .howitworks-wrapper': {
        maxWidth: 1280,
        margin: '0 auto',
        padding: 0,
      },

      '& .howitworks-wrapper-left': {
        padding: '0 !important',
      },

      '& .how-cover-image': {
        backgroundSize: 'contain',
        display: 'block',
        height: 640,
        margin: '0 auto',
        maxWidth: 600,
        objectFit: 'contain',
        width: '100%',
      },

      '& .howitworks-grid': {
        alignItems: 'center',
        columnGap: 120,
        flexWrap: 'nowrap',
        margin: 0,
        width: '100%',
      },

      '& .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
        {
          flexBasis: 'auto',
          maxWidth: 'none',
          padding: '0 !important',
        },

      '& .howitworks-grid > .howitworks-wrapper-left': {
        flex: '1 1 0',
        minWidth: 0,
      },

      '& .howitworks-content-grid, & .howitworks-wrapper-left > .MuiGrid-container': {
        margin: 0,
        width: '100%',
      },

      '& .howitworks-content-grid > .MuiGrid-item, & .howitworks-wrapper-left > .MuiGrid-container > .MuiGrid-item':
        {
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        },

      '& .howitworks-grid > .cover-image-wrapper': {
        flex: '0 0 600px',
        maxWidth: 600,
        minWidth: 600,
      },

      '& .howitworks-title': {
        marginBottom: 40,
        padding: '0 !important',
      },

      '& .howitworks-title .section-header': {
        gap: 12,
      },

      '& .howitworks-title .section-header__overline-wrapper': {
        color: palette.primary.main,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
        padding: '0 !important',
        textTransform: 'uppercase',
      },

      '& .howitworks-title .section-header__title-wrapper, & .howitworks-title .section-header__subtitle-wrapper':
        {
          padding: '0 !important',
        },

      '& .howitworks-title .section-header__title': {
        color: palette.text.heading,
        fontSize: 36,
        fontWeight: 400,
        letterSpacing: '-1.44px',
        lineHeight: '40px',
        maxWidth: 500,
        padding: '0 !important',
      },

      '& .howitworks-title .section-header__subtitle': {
        color: palette.text.body,
        fontSize: 20,
        fontWeight: 400,
        letterSpacing: '-0.8px',
        lineHeight: '26px',
        maxWidth: 560,
      },

      '& .working-steps-main-container': {
        padding: '0 !important',
      },

      '& .working-steps-container': {
        margin: '0 !important',
        padding: '24px 0',
        position: 'relative',
      },

      '& .working-steps-container:first-child': {
        paddingTop: 0,
      },

      '& .working-steps-container:not(:last-child)': {
        borderBottom: `1px solid ${palette.text.border}`,
      },

      '& .working-steps-container .step-counter-item, & .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item':
        {
          padding: '0 !important',
        },

      '& .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item:nth-child(2)':
        {
          paddingLeft: '24px !important',
        },

      '& .step-counter': {
        alignItems: 'center',
        backgroundColor: palette.primary.main,
        borderRadius: '50%',
        color: palette.text.highlight,
        display: 'inline-flex',
        fontSize: 14,
        fontWeight: 500,
        height: 40,
        justifyContent: 'center',
        letterSpacing: '-0.28px',
        lineHeight: '20px',
        minWidth: 40,
        width: 40,
      },

      '& .step-title': {
        color: palette.text.heading,
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.48px',
        lineHeight: '28px',
        marginBottom: 10,
      },

      '& .step-content': {
        color: palette.text.body,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.64px',
        lineHeight: '22px',
        maxWidth: 520,
      },

      '& .step-started-button': {
        '& .right-icon': {
          color: palette.text.highlight,
        },
      },

      '@media screen and (min-width: 900px) and (max-width: 1200px)': {
        padding: '72px 48px',

        '& .howitworks-grid': {
          columnGap: 48,
        },

        '& .howitworks-grid > .cover-image-wrapper': {
          flex: '0 0 44%',
          maxWidth: '44%',
          minWidth: 0,
        },

        '& .howitworks-grid > .howitworks-wrapper-left': {
          flex: '1 1 0',
        },

        '& .how-cover-image': {
          height: 'auto',
          maxHeight: 520,
          maxWidth: '100%',
        },

        '& .howitworks-title .section-header__title': {
          fontSize: 36,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
          maxWidth: 420,
        },

        '& .howitworks-title .section-header__subtitle': {
          fontSize: 18,
          lineHeight: '24px',
          maxWidth: 420,
        },
      },

      '@media screen and (max-width: 900px)': {
        boxSizing: 'border-box',
        overflowX: 'hidden',
        padding: '56px 24px',

        '& .section': {
          paddingLeft: '0 !important',
          paddingRight: '0 !important',
        },

        '& .howitworks-wrapper': {
          maxWidth: '100%',
          width: '100%',
        },

        '& .howitworks-grid, & .howitworks-content-grid, & .howitworks-wrapper-left > .MuiGrid-container, & .working-steps-container':
          {
            margin: '0 !important',
            maxWidth: '100% !important',
            width: '100% !important',
          },

        '& .howitworks-content-grid > .MuiGrid-item, & .howitworks-wrapper-left > .MuiGrid-container > .MuiGrid-item, & .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
          {
            maxWidth: '100%',
            padding: '0 !important',
          },

        '& .working-steps-main-container': {
          maxWidth: '100%',
          width: '100%',
        },

        '& .working-steps-container': {
          boxSizing: 'border-box',
          maxWidth: '100%',
          width: '100%',
        },

        '& .working-steps-container .step-counter-item, & .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item':
          {
            minWidth: 0,
            padding: '0 !important',
          },

        '& .working-steps-container .step-content-item, & .working-steps-container > .MuiGrid-item:nth-child(2)':
          {
            flex: '1 1 0',
            maxWidth: 'calc(100% - 40px)',
            paddingLeft: '16px !important',
          },

        '& .step-title, & .step-content': {
          maxWidth: '100%',
          overflowWrap: 'break-word',
          wordBreak: 'break-word',
        },

        '& .howitworks-grid': {
          flexWrap: 'wrap',
          rowGap: 40,
        },

        '& .howitworks-grid > .howitworks-wrapper-left, & .howitworks-grid > .cover-image-wrapper, & .howitworks-grid > .MuiGrid-item':
          {
            flexBasis: '100%',
            maxWidth: '100%',
          },

        '& .howitworks-grid > .cover-image-wrapper': {
          flex: '0 0 100%',
          maxWidth: '100%',
          minWidth: 0,
          overflow: 'hidden',
        },

        '& .howitworks-wrapper-left': {
          padding: '0 !important',
        },

        '& .how-cover-image': {
          height: 'auto',
          maxHeight: 520,
          maxWidth: '100%',
        },

        '& .howitworks-title .section-header__title': {
          fontSize: 32,
          letterSpacing: '-1px',
          lineHeight: '40px',
        },

        '& .howitworks-title .section-header': {
          margin: '0 !important',
          maxWidth: '100%',
          width: '100%',
        },

        '& .howitworks-title .section-header > .MuiGrid-item': {
          padding: '0 !important',
        },

        '& .howitworks-title .section-header__subtitle': {
          maxWidth: '100%',
        },
      },

      '@media(min-width: 900px)': {
        '& .howitworks-wrapper-left': {
          paddingLeft: '100px',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      backgroundImage: `url(${testimonialBg})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      '& .testimonial-message': {
        color: palette.text.body,
        fontWeight: 300,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ Section */
    '& .FAQSection': {
      padding: '96px 0',
      position: 'relative',
      maxWidth: 'none !important',
      width: '100%',
      background: palette.background.aboutFaq,

      '& .faq-variant2-wrapper': {
        margin: '0 auto',
        maxWidth: 1280,
        padding: '0 112px',
        width: 'calc(100% - 96px)',
      },

      '& .faq-variant2-wrapper > .MuiGrid-container': {
        flexDirection: 'column',
        gap: 56,
        margin: 0,
        width: '100%',
      },

      '& .faq-variant2-wrapper > .MuiGrid-container > .MuiGrid-item': {
        flexBasis: '100%',
        maxWidth: '100%',
        padding: '0 !important',
        width: '100%',
      },

      '& .section-header': {
        alignItems: 'center',
        margin: 0,
      },

      '& .section-header__overline-wrapper': {
        display: 'none',
      },

      '& .section-header__title-wrapper': {
        padding: '0 !important',
      },

      '& .section-header__title': {
        color: palette.text.primary,
        fontSize: 48,
        fontWeight: 400,
        letterSpacing: '-1.92px',
        lineHeight: '56px',
        padding: '0 !important',
        textAlign: 'center',
      },

      '& .faq-variant2-wrapper .accordion': {
        gap: 24,
      },

      '& .faq-variant2-wrapper .MuiAccordion-root': {
        background: palette.text.highlight,
      },

      '& .accordion__item-wrapper': {
        border: `1px solid ${palette.text.border}`,
        borderRadius: '8px !important',
        boxShadow: 'none',
        margin: '0 !important',
        overflow: 'hidden',
        padding: 0,
      },

      '& .accordion__item-wrapper::before': {
        display: 'none',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-root': {
        minHeight: 72,
        padding: '0 24px',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-root.Mui-expanded': {
        minHeight: 72,
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-content': {
        margin: '0 !important',
      },

      '& .accordion__item-wrapper .MuiAccordionSummary-expandIcon': {
        padding: 0,
      },

      '& .accordion__item-wrapper .expandIcon, & .accordion__item-wrapper .collapseIcon':
        {
          color: `${palette.primary.main} !important`,
          fontSize: 24,
        },

      '& .accorion_item-title, & .accorion__item-title-container .MuiTypography-root':
        {
        color: `${palette.text.primary} !important`,
        fontSize: 18,
        fontWeight: '500 !important',
        letterSpacing: '-0.72px',
        lineHeight: '24px',
      },

      '& .accordion__item-wrapper.Mui-expanded .accorion_item-title, & .accordion__item-wrapper.Mui-expanded .accorion__item-title-container .MuiTypography-root':
        {
        color: `${palette.primary.main} !important`,
      },

      '& .accordion__item-wrapper .MuiAccordionDetails-root': {
        padding: '0 88px 24px 24px',
      },

      '& .accordion__collapsable-text-container': {
        margin: 0,
        width: '100%',
      },

      '& .accordion__collapsable-text-wrapper': {
        padding: '0 !important',
      },

      '& .accordion__collapsable-text': {
        color: palette.text.body,
        fontSize: 14,
        fontWeight: 400,
        letterSpacing: '-0.28px',
        lineHeight: '18px',
      },

      '@media screen and (max-width: 1200px)': {
        '& .faq-variant2-wrapper': {
          padding: '0 48px',
          width: 'calc(100% - 48px)',
        },
      },

      '@media screen and (max-width: 900px)': {
        padding: '56px 24px',

        '& .faq-variant2-wrapper': {
          padding: 0,
          width: '100%',
        },

        '& .faq-variant2-wrapper > .MuiGrid-container': {
          gap: 40,
        },

        '& .section-header__title': {
          fontSize: 32,
          lineHeight: '40px',
        },

        '& .accordion__item-wrapper .MuiAccordionSummary-root': {
          padding: '0 18px',
        },

        '& .accordion__item-wrapper .MuiAccordionDetails-root': {
          padding: '0 18px 18px',
        },
      },
    },

    '& .dashboard-main-container .dashboard-have-questions-section .MuiPaper-root.widget':
      {
        background: `linear-gradient(90deg, ${palette.background.aboutBenefitsOverlay} 0%, ${palette.background.aboutBenefitsOverlay} 100%), linear-gradient(90deg, ${palette.background.questions} 0%, ${palette.background.questions} 100%)`,
        border: `1px solid ${palette.primary.main}`,
        borderRadius: 20,
        color: palette.text.questions,
        padding: '32px 24px',
        paddingBottom: 55,

        '& .MuiTypography-h5': {
          color: palette.text.questions,
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: '0.75px',
          lineHeight: '28px',
          marginBottom: 4,
        },

        '& .MuiTypography-body1': {
          color: palette.text.body,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },

        '& .MuiTypography-subtitle1, & .MuiListItemText-primary .MuiTypography-root':
          {
            color: `${palette.text.questions} !important`,
            fontSize: 16,
            fontWeight: 400,
            letterSpacing: '-0.64px',
            lineHeight: '22px',
          },

        '& .MuiListItem-root': {
          padding: '8px 0',
        },

        '& .MuiListItemAvatar-root': {
          minWidth: 36,
        },

        '& .MuiSvgIcon-root': {
          color: `${palette.primary.main} !important`,
          fontSize: 28,
        },

        '& .MuiDivider-root': {
          backgroundColor: palette.background.questionsDivider,
          margin: '20px 0',
        },

        '& .dashboard-have-questions-footer .MuiTypography-root': {
          color: palette.text.primary,
          fontSize: 16,
          fontWeight: 400,
          letterSpacing: '-0.64px',
          lineHeight: '22px',
        },

        '& .dashboard-have-questions-footer .MuiLink-root': {
          color: `${palette.primary.main} !important`,
        },

        '& .dashboard-have-questions-footer + .dashboard-have-questions-footer': {
          marginTop: '12px !important',
        },

        '& .MuiListItemText-root .MuiLink-root': {
          color: `${palette.text.questions} !important`,
          textDecoration: 'none',
        },
      },
    '& .dashboard-main-container .dashboard-subscription-details-section .MuiPaper-root.widget .description-cta, & .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .description-cta':
      {
        backgroundColor: `${palette.background.paper} !important`,
        borderBottomColor: palette.text.border,
      },
    '& .dashboard-main-container .dashboard-subscription-details-section .description-cta, & .dashboard-main-container .dashboard-payment-details-section .description-cta, & .dashboard-main-container .dashboard-benefits-usage-section .description-cta, & .dashboard-main-container .dashboard-subscription-details-section [class*="titleCont"], & .dashboard-main-container .dashboard-payment-details-section [class*="titleCont"], & .dashboard-main-container .dashboard-benefits-usage-section [class*="titleCont"]':
      {
        backgroundColor: `${palette.background.paper} !important`,
        borderBottomColor: palette.text.border,
      },
    '& .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .benefits-done-wrappper':
      {
        background: `transparent url(${YesIcon}) center / contain no-repeat`,
      },
    '& .dashboard-main-container .dashboard-benefits-usage-section .MuiPaper-root.benefits-widget .benefits-done-icon':
      {
        opacity: 0,
      },

    '@media screen and (max-width: 1200px)': {
      '& .FAQSection::after': {
        height: '34vw',
        width: '47vw',
      },
    },

    '@media screen and (max-width: 900px)': {
      '& .FAQSection::after': {
        display: 'none',
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .savings-hero-section': {
        background: palette.background.alternate,
        marginBottom: 0,

        '& .section': {
          padding: '80px 32px !important',
        },

        '& .hero-header-title': {
          color: `${palette.text.highlight} !important`,
          fontSize: 36,
          fontWeight: 400,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
        },

        '& .hero-header-subtitle': {
          color: `${palette.text.highlight} !important`,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },
      },
      '& .section-header': {
        '& .section-header__title': {
          color: `${palette.text.heading} !important`,
          fontSize: 36,
          fontWeight: 400,
          letterSpacing: '-1.44px',
          lineHeight: '40px',
        },
        '& .section-header__subtitle': {
          color: `${palette.text.body} !important`,
          fontSize: 18,
          fontWeight: 400,
          letterSpacing: '-0.54px',
          lineHeight: '24px',
        },
      },
      '& .savings-hero-section .hero-home-button': {
        background: 'transparent',
        border: `1px solid ${palette.text.highlight}`,
        borderRadius: 12,
        color: `${palette.text.highlight} !important`,
        fontSize: 16,
        fontWeight: 400,
        letterSpacing: '-0.32px',
        lineHeight: '20px',
        minWidth: 144,
        padding: '12px 24px',

        '&:hover': {
          background: 'rgba(255, 255, 255, 0.12)',
          border: `1px solid ${palette.text.highlight}`,
          color: `${palette.text.highlight} !important`,
        },
      },
      '& .service-plan-table': {
        borderColor: `${palette.background.tableHead} !important`,
        '& .savings-topheader': {
          color: `${palette.text.highlight} !important`,
          borderTop: 'none !important',
          borderBottom: 'none !important',
          borderLeft: 'none !important',
          '&:not(:last-child)': {
            borderRight: `1px solid ${palette.text.highlight} !important`,
          },
        },

        '& .savings-header': {
          color: palette.text.body,
        },

        '& .savings-subheader': {
          backgroundColor: palette.background.main,
          color: palette.text.primary,
          fontWeight: 600,
        },
      },

      '& .view-more-button': {
        background: palette.background.alternate,
        borderColor: palette.background.alternate,
        color: palette.text.highlight,

        '&:hover': {
          background: palette.primary.main,
          borderColor: palette.primary.main,
          color: palette.text.highlight,
        },
      },

      '& .savings-contact-card': {
        background: palette.text.highlight,

        '@media screen and (max-width: 900px)': {
          marginTop: '0 !important',
          padding: '0 !important',

          '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
            {
              justifyContent: 'center',
              textAlign: 'center',
            },

          '& .contact-card-title, & .contact-card-subtitle, & .section-header__title, & .section-header__subtitle':
            {
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center !important',
            },

          '& .contact-card-subtitle': {
            maxWidth: '100%',
          },
        },
      },
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.text.highlight,
      },
      '& .section-header__subtitle': {
        color: palette.text.body,
      },
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.border}`,
      },
      '& .addon-bg': {
        background: palette.background.secondaryLight,
      },
      '& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track': {
        background: palette.background.light,
        border: `1px solid ${palette.primary.main}`,
        opacity: 1,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
    },

    /* Create Subscriber - Choose plan */
    '& .plan-selection-container': {
      '& .plans-wrapper': {
        '& .planCard': {
          border: `1px solid ${palette.text.primary}`,
          '& .price-value, .display-frequency': {
            color: palette.secondary.main,
          },
          '&:hover': {
            color: palette.text.primary,
            background: palette.text.highlight,
          },
          '& .highlight-divider': {
            backgroundColor: palette.text.highlight,
          },
          '& .planCardDescription': {
            height: 'calc(100% - 24px)',
          },
        },
      },
      '& .primary-static-button': {
        background: palette.primary.main,
      },
      '& .react-multi-carousel-dot button': {
        background: palette.primary.main,
      },
    },

    /* FAQ */
    '& .faq-hero-section': {
      backgroundImage: `url(${background})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',

      '& .hero-header-title, .hero-header-subtitle': {
        margin: '0',
        textAlign: 'left',
      },
      '& .hero-header-subtitle': {
        color: `${palette.text.body} !important`,
      },
      '& .header-container': {
        justifyContent: 'left',
        margin: '0',
      },
      '& .section': {
        marginLeft: 64,
        '@media(max-width: 900px)': {
          marginLeft: 0,
        },
      },
    },
    '& .faqInnerContainer': {
      '& .accordion__collapsable-text': {
        color: palette.text.body,
      },
      '& .faq-link': {
        fontWeight: 500,
      },
    },
    '& .faq-contact-section': {
      background: palette.text.highlight,
      '& .contact-img-wrapper': {
        width: '64px',
        maxWidth: '64px',
      },
      '& .contact-card-subtitle': {
        color: palette.text.body,
      },
      '& .provider-contact-details': {
        fontWeight: 500,
        color: palette.text.body,
      },
      '& .provider-contact-link': {
        color: palette.text.primary,
      },
      '@media screen and (max-width: 900px)': {
        padding: '40px 24px !important',

        '& .section-header, & .section-header__title-wrapper, & .section-header__subtitle-wrapper':
          {
            justifyContent: 'center',
            textAlign: 'center',
          },

        '& .contact-card-title, & .contact-card-subtitle, & .section-header__title, & .section-header__subtitle':
          {
            marginLeft: 'auto',
            marginRight: 'auto',
            textAlign: 'center !important',
          },

        '& .contact-card-subtitle': {
          maxWidth: '100%',
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
      '& .termsText': {
        fontFamily: 'auto',
        fontWeight: 'bold',
      },
    },

    /* Contact Card - FAQ, Success Page */
    '& .faq-contact-wrapper': {
      background: palette.text.highlight,
      '& .contact-card-title': {
        fontWeight: 500,
        fontSize: 40,
        '@media screen and (max-width: 768px)': {
          fontSize: 30,
        },
      }
    },
    '& .mail-link': {
      color: palette.text.primary,
    },

    /* About Page - Styles */
    '& .about-page': {
      marginTop: 0,

      '& .about-hero-section': {
        background: `linear-gradient(90deg, ${palette.background.aboutHeroOverlay} 0%, ${palette.background.aboutHeroOverlay} 100%), ${palette.background.paper}`,
        padding: 0,

        '& .about-hero-wrapper, & > .MuiBox-root': {
          maxWidth: 1600,
          width: '100%',
          margin: '0 auto',
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 80,
          paddingRight: 64,

          '@media screen and (max-width: 600px)': {
            paddingLeft: 24,
            paddingRight: 24,
            paddingTop: 0,
            paddingBottom: 0,
          },
        },

        '@media screen and (max-width: 900px)': {
          '& .about-hero-content, & > .MuiBox-root > .MuiBox-root:first-of-type':
            {
              marginLeft: 'auto',
              marginRight: 'auto',
              maxWidth: '100%',
              textAlign: 'center',
            },

          '& .about-hero-pretitle, & > .MuiBox-root > .MuiBox-root:first-of-type > p:first-of-type, & .about-hero-content h1, & h1, & .about-hero-subtitle, & h1 + p':
            {
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            },

          '& .about-hero-subtitle, & h1 + p': {
            maxWidth: '100%',
          },

          '& .about-hero-cta, & > .MuiBox-root > .MuiBox-root:first-of-type > .MuiBox-root:last-of-type':
            {
              justifyContent: 'center',
              marginTop: '40px !important',
            },
        },

        '& .about-hero-content, & > .MuiBox-root > .MuiBox-root:first-of-type': {
          maxWidth: 640,
        },

        '& .about-hero-pretitle, & > .MuiBox-root > .MuiBox-root:first-of-type > p:first-of-type':
          {
            color: palette.primary.main,
            fontSize: '24px',
            fontWeight: 500,
            letterSpacing: '-0.96px',
            lineHeight: '28px',
            margin: '0 0 40px !important',
          },

        '& h1': {
          color: palette.text.primary,
          fontSize: '64px',
          fontWeight: 400,
          letterSpacing: '-3.2px',
          lineHeight: '72px',
          margin: '0 0 40px !important',

          '@media screen and (max-width: 768px)': {
            fontSize: '40px',
            letterSpacing: '-1.6px',
            lineHeight: '48px',
          },
        },

        '& h1 span': {
          color: palette.primary.main,
          fontWeight: 'inherit',
        },

        '& .about-hero-subtitle, & h1 + p': {
          color: palette.text.secondary,
          fontSize: '20px',
          fontWeight: 400,
          letterSpacing: '-0.8px',
          lineHeight: '26px',
          margin: '0 0 40px !important',
          maxWidth: 640,
        },

        '& .about-hero-cta, & > .MuiBox-root > .MuiBox-root:first-of-type > .MuiBox-root:last-of-type':
          {
            gap: 16,
            marginTop: '90px !important',
          },

        '& .MuiButton-root': {
          borderRadius: 12,
          fontSize: '16px !important',
          fontWeight: 400,
          letterSpacing: '-0.32px',
          lineHeight: '20px',
          padding: '12px 24px !important',
        },

        '& .MuiButton-outlinedPrimary': {
          color: palette.primary.main,
        },
      },
    },
    '& .about-benefits-section': {
      background: `linear-gradient(90deg, ${palette.background.aboutBenefitsOverlay} 0%, ${palette.background.aboutBenefitsOverlay} 100%), ${palette.background.aboutBenefits}`,
    },
    '& .about-partners-section, & .dashboard-partners-section': {
      '& .about-partner-card': {
        borderColor: palette.background.aboutBorder,
      },

      '& h2 + p': {
        color: `${palette.text.body} !important`,
      },

      '& .about-partner-card h3 + p': {
        color: `${palette.text.body} !important`,
      },
    },
    '& .about-partners-section': {
      background: palette.background.aboutPartners,
    },
    '& .dashboard-partners-section': {
      padding: 0,
      background: `${palette.background.paper} !important`,

      '& .partners-section-wrapper': {
        margin: 0,
        maxWidth: 'none',
        gap: 16,
      },

      '& .partners-section-header': {
        alignItems: 'flex-start',
        margin: 0,
        maxWidth: 'none',
        textAlign: 'left',

        '& h2': {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: '0.75px',
          lineHeight: '28px',
        },
      },
    },
    '& .about-how-it-works-section': {
      background: palette.background.aboutHowItWorks,

      '& .about-how-it-works-pretitle': {
        fontSize: 24,
        fontWeight: 500,
        letterSpacing: '-0.96px',
        lineHeight: '28px',
      },

      '& .about-how-it-works-title': {
        color: palette.text.heading,
        fontSize: 36,
        fontWeight: 400,
        letterSpacing: '-1.44px',
        lineHeight: '40px',
      },

      '@media screen and (max-width: 900px)': {
        '& .about-how-it-works-title': {
          fontSize: 32,
          letterSpacing: '-1px',
          lineHeight: '40px',
        },
      },
    },
    '& .about-step-item:not(:last-child)': {
      borderBottom: `1px solid ${palette.background.aboutStepDivider}`,
    },
    '& .about-faq-section': {
      background: palette.background.aboutFaq,

      '& .accordion__item-wrapper': {
        border: `1px solid ${palette.background.aboutBorder}`,
      },
    },

    /* Footer Style */
    '& .footer-wrapper': {
      background: palette.background.footer
    },

    /* Dashboard Page - Appointment Header */
    '& .MuiTableRow-root .MuiTableCell-head': {
      color: palette.text.highlight,
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: palette.background.alternate,
      },
      '& .stepperIconActive': {
        color: `${palette.primary.main} !important`,
        '& .stepperIconText': {
          fill: palette.text.highlight,
        },
      },
      '& .stepperIconRoot': {
        color: 'transparent',
        borderColor: palette.primary.main,
        '& .stepperIconText': {
          fill: palette.primary.main,
        },
      },
      '& .stepperIconCompleted': {
        color: palette.primary.main,
      },
    },
  },

  '.success-wrapper': {
    '& .cancel-button': {
      color: palette.primary.main,
    },
  },
};
